if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector("span");

        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");

        this.hideErrors = this.dataset.hideErrors === "true";
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        const productInfoEl = this.closest('product-info');
        const mainQuantityEl = productInfoEl ? productInfoEl.querySelector('.quantity__input') : null;

        if (mainQuantityEl) {
          const formQuantityEl = this.form.querySelector('input[name="quantity"]');

          if (formQuantityEl) {
            formQuantityEl.value = mainQuantityEl.value;
          } else {
            let hiddenQty = this.form.querySelector('input[name="quantity"]._generated_quantity_input');
            if (!hiddenQty) {
              hiddenQty = document.createElement('input');
              hiddenQty.type = 'hidden';
              hiddenQty.name = 'quantity';
              hiddenQty.className = '_generated_quantity_input';
              this.form.appendChild(hiddenQty);
            }
            hiddenQty.value = mainQuantityEl.value;
          }
        }

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id),
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        if (formData.get("increment")) {
          formData.set("quantity", formData.get("increment"));
        }
        if (formData.get("product_complementary_modal_url") != null) {
          // Remove old complementary modal if exists
          if (document.getElementById("QuickAdd-Complementary") != null)
            document.getElementById("QuickAdd-Complementary").remove();

          // Open modal with its content
          const productElm = document.querySelector(".product");
          const productModal = formData.get("product_complementary_modal_url");
          const currentUrl = new URL(window.location.href);
          const variantId = currentUrl.searchParams.get("variant") ?? "";

          return fetch(productModal)
            .then((res) => res.text())
            .then((res) => {
              const text = res;
              const parser = new DOMParser();
              const htmlDocument = parser.parseFromString(text, "text/html");
              htmlDocument
                .querySelectorAll('[name="quantity"]')
                .forEach((quantity) => {
                  quantity.value = document.querySelector(
                    "quantity-input .quantity__input",
                  ).value;
                });
              if (variantId != "") {
                htmlDocument
                  .querySelectorAll('[name="id"]')
                  .forEach((idInput) => {
                    idInput.value = variantId;
                  });
              }
              const productCard =
                htmlDocument.documentElement.querySelector("body").firstChild;
              productElm.insertAdjacentElement("afterend", productCard);
            })
            .catch((err) =>
              console.error(
                `Failed to load content for handle: ${handle}`,
                err,
              ),
            );
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading__spinner").classList.remove("hidden");

        if (formData.getAll("bundles[]").length > 0) {
          config.body = Object.fromEntries(formData);
          config.body["items"] = [];

          formData.getAll("bundles[]").forEach((bundle) => {
            const productAndDockeyData = atob(bundle).split("||dockeys=");
            const productData = JSON.parse(productAndDockeyData[0]);
            var properties = {
              _bundleParentId: formData.get("id"),
            };

            if (typeof productAndDockeyData[1] !== "undefined") {
              if (getCookie("dockey")) {
                const dockeyValues = productAndDockeyData[1].split(",");

                if (dockeyValues.includes(getCookie("dockey"))) {
                  properties.dockey = getCookie("dockey");
                }
              }
            }

            config.body["items"].push({
              id: productData.id,
              quantity: formData.get("quantity"),
              properties: properties,
            });
          });

          config.body = JSON.stringify(config.body);
        } else if (formData.getAll("split_products_bundle").length > 0) {
          config.body = Object.fromEntries(formData);
          config.body["items"] = [];

          // Adds the bundle items
          formData.getAll("split_products_bundle").forEach((bundle) => {
            const splitProductData = atob(bundle).split("|");
            const productData = JSON.parse(splitProductData[0]);

            config.body["items"].push({
              id: productData.id,
              quantity: formData.get("quantity"),
            });
          });

          // Sets the parent product quantity to 0 to only add the bundle items
          config.body.quantity = 0;

          config.body = JSON.stringify(config.body);
        } else {
          delete config.headers["Content-Type"];
          config.body = formData;
        }

        if (formData.get("properties[_supportedDockeys]")) {
          if (getCookie("dockey")) {
            const dockeyValues = formData
              .get("properties[_supportedDockeys]")
              .split(",");

            if (dockeyValues.includes(getCookie("dockey"))) {
              formData.set("properties[dockey]", getCookie("dockey"));
            }
          }
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButtonText.classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            this.error = false;

            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal && !formData.get("change_label")) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true },
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            if (formData.get("change_label")) {
              this.submitButton.setAttribute("disabled", "true");
              this.submitButton.querySelector("span").innerHTML =
                formData.get("change_label");
            }

            if (document.getElementById("free-shipping-bar") != null) {
              const freeShippingBar = new Fsb();
              freeShippingBar.updateAjax();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner").classList.add("hidden");
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    },
  );
  const quantityInput = document.querySelector(".quantity__input");
  const minValue = Number(quantityInput.getAttribute("min"));
  const event = new Event("change");

  quantityInput.addEventListener("focusout", function () {
    const quantity = Number(this.value);

    if (quantity < minValue) {
      this.value = minValue;
      quantityInput.dispatchEvent(event);

      return;
    } else if (quantity % minValue !== 0) {
      this.value = quantity - (quantity % minValue);
      quantityInput.dispatchEvent(event);

      return;
    }
  });
  quantityInput.dispatchEvent(event);
}
